import Error from "../../Components/Utils/Error/Error"


const ErrorPage = () => {
  return (
    <Error />
  )
}

export default ErrorPage;